export const ACCEPTED_FORMATS =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx';
